/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';

import {ReleaseNotesHelper} from '../../../components/util/release-notes-helper.service';
import template from './release-notes-list-page.component.html';
import {createBufferedFlag, readBufferedFlag} from '../../common/util/template-state';

@Component({
  standalone: false,
  selector: 'adn-release-notes-list-page',
  template
})
export class ReleaseNotesListPageComponent implements OnInit, OnDestroy {
  notes: any[] = [];
  showList = 'ACTIVE';
  loaded = false;
  private readonly loadedFlag = createBufferedFlag();
  private destroyed = false;
  loadError = '';

  constructor(
    private readonly releaseNotesHelper: ReleaseNotesHelper,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  get displayLoaded(): boolean {
    return readBufferedFlag(this.loadedFlag, this.loaded, this.cdr, () => !this.destroyed);
  }

  ngOnInit(): void {
    this.loadNotes();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  onShowListChange(): void {
    this.loadNotes();
  }

  private loadNotes(): void {
    this.loaded = false;
    this.loadError = '';
    this.releaseNotesHelper.query(null, true, this.showList).then((data: any[]) => {
      this.notes = data || [];
      this.loaded = true;
    }).catch(() => {
      this.notes = [];
      this.loadError = 'Release notes could not be loaded.';
      this.loaded = true;
    });
  }
}
